<header class="marketing-header">
  <div class="header-container">
    <!-- Branding - Left Side -->
    <div class="header-brand">
      <a routerLink="/home" class="brand-link">
        <div class="brand-logo">
          <img src="/assets/images/file.svg.svg" alt="EntropyGroupLimited Logo" />
        </div>
        <div class="brand-text">
          <span class="brand-name">EntropyGroupLimited</span>
          <span class="brand-tagline">Inc</span>
        </div>
      </a>
    </div>

    <!-- Navigation - Desktop Only -->
    <nav class="header-nav">
      <a
        routerLink="/home"
        class="nav-item"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        Home
      </a>
      <a routerLink="/about" class="nav-item" routerLinkActive="active">About</a>
      <a routerLink="/services" class="nav-item" routerLinkActive="active">Services</a>
      <a routerLink="/account" class="nav-item" routerLinkActive="active">Account</a>
      <a routerLink="/contact" class="nav-item" routerLinkActive="active">Contact</a>
    </nav>

    <!-- Mobile Dropdown -->
    <div class="mobile-dropdown-wrapper">
      <button
        class="mobile-toggle"
        (click)="toggleMobileMenu()"
        [attr.aria-expanded]="mobileMenuOpen"
        aria-haspopup="true"
        aria-label="Toggle menu"
      >
        <div class="hamburger" [class.open]="mobileMenuOpen">
          <span class="line"></span>
          <span class="line"></span>
          <span class="line"></span>
        </div>
      </button>

      @if (mobileMenuOpen) {
        <div class="mobile-dropdown" role="menu" aria-orientation="vertical">
          <a
            routerLink="/home"
            class="dropdown-item"
            role="menuitem"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="closeMobileMenu()"
          >
            Home
          </a>
          <a
            routerLink="/about"
            class="dropdown-item"
            role="menuitem"
            routerLinkActive="active"
            (click)="closeMobileMenu()"
          >
            About
          </a>
          <a
            routerLink="/services"
            class="dropdown-item"
            role="menuitem"
            routerLinkActive="active"
            (click)="closeMobileMenu()"
          >
            Services
          </a>
          <a
            routerLink="/account"
            class="dropdown-item"
            role="menuitem"
            routerLinkActive="active"
            (click)="closeMobileMenu()"
          >
            Account
          </a>
          <a
            routerLink="/contact"
            class="dropdown-item"
            role="menuitem"
            routerLinkActive="active"
            (click)="closeMobileMenu()"
          >
            Contact
          </a>
        </div>
      }
    </div>
  </div>
</header>
